var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { autoinject } from "aurelia-dependency-injection";
var CacheClient = /** @class */ (function () {
    function CacheClient() {
        this.sessionStorageHolder = new SessionStorage();
    }
    CacheClient.prototype.isUndefined = function (x) {
        return x == null || x == undefined || x == "null" || x == "undefined";
    };
    CacheClient.prototype.put = function (key, value, location) {
        var _this = this;
        if (location === void 0) { location = CacheLocation.LocalStorage; }
        return new Promise(function (resolve, reject) {
            try {
                if (_this.isUndefined(value))
                    _this.remove(key);
                else if (key) {
                    switch (location) {
                        case CacheLocation.LocalStorage:
                            localStorage.setItem(key, JSON.stringify(value));
                            break;
                        case CacheLocation.SessionStorage:
                            _this.sessionStorageHolder.addItem(key, value);
                            break;
                    }
                }
                resolve(undefined);
            }
            catch (_a) {
                resolve(undefined);
            }
        });
    };
    CacheClient.prototype.startsWith = function (str, searchString) {
        return str.substr(0, searchString.length) === searchString;
    };
    CacheClient.prototype.getKeysByCacheCategory = function (category, location) {
        var _this = this;
        if (location === void 0) { location = CacheLocation.LocalStorage; }
        return new Promise(function (resolve, reject) {
            try {
                var keys = _this.getKeys(location);
                Promise.all(keys
                    .filter(function (x) { return x.startsWith(category); })
                    .map(function (x) { return _this.get(x, location); }));
                resolve(undefined);
            }
            catch (_a) {
                resolve(undefined);
            }
        });
    };
    CacheClient.prototype.getKeys = function (location) {
        if (location === void 0) { location = CacheLocation.LocalStorage; }
        switch (location) {
            case CacheLocation.LocalStorage: {
                var keys = [];
                for (var key in localStorage) {
                    keys.push(key);
                }
                return keys;
            }
            case CacheLocation.SessionStorage: {
                return this.sessionStorageHolder.getKeys();
            }
        }
    };
    CacheClient.prototype.get = function (key, location) {
        var _this = this;
        if (location === void 0) { location = CacheLocation.LocalStorage; }
        return new Promise(function (resolve, reject) {
            try {
                if (key) {
                    switch (location) {
                        case CacheLocation.LocalStorage: {
                            var obj = localStorage.getItem(key);
                            if (!_this.isUndefined(obj))
                                resolve(JSON.parse(obj));
                        }
                        case CacheLocation.SessionStorage:
                            resolve(_this.sessionStorageHolder.getItem(key));
                    }
                }
                resolve(undefined);
            }
            catch (_a) {
                resolve(undefined);
            }
        });
    };
    CacheClient.prototype.remove = function (key, location) {
        var _this = this;
        if (location === void 0) { location = CacheLocation.LocalStorage; }
        return new Promise(function (resolve, reject) {
            try {
                switch (location) {
                    case CacheLocation.LocalStorage:
                        localStorage.removeItem(key);
                        break;
                    case CacheLocation.SessionStorage:
                        _this.sessionStorageHolder.removeItem(key);
                        break;
                }
                resolve(undefined);
            }
            catch (_a) {
                resolve(undefined);
            }
        });
    };
    CacheClient.prototype.removeKeyContains = function (xKey, location) {
        var e_1, _a;
        if (location === void 0) { location = CacheLocation.LocalStorage; }
        try {
            var keys = this.getKeys(location);
            var toRemove = keys
                .filter(function (x) { return x.toLowerCase().indexOf(xKey.toLowerCase()) !== -1; });
            try {
                for (var toRemove_1 = __values(toRemove), toRemove_1_1 = toRemove_1.next(); !toRemove_1_1.done; toRemove_1_1 = toRemove_1.next()) {
                    var r = toRemove_1_1.value;
                    this.remove(r, location);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (toRemove_1_1 && !toRemove_1_1.done && (_a = toRemove_1.return)) _a.call(toRemove_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        catch (_b) {
        }
    };
    CacheClient = __decorate([
        autoinject
    ], CacheClient);
    return CacheClient;
}());
export { CacheClient };
export var CacheLocation;
(function (CacheLocation) {
    CacheLocation[CacheLocation["SessionStorage"] = 0] = "SessionStorage";
    CacheLocation[CacheLocation["LocalStorage"] = 1] = "LocalStorage";
})(CacheLocation || (CacheLocation = {}));
var SessionStorage = /** @class */ (function () {
    function SessionStorage() {
        this._internalStorage = {};
    }
    SessionStorage.prototype.addItem = function (key, item) {
        this._internalStorage[key] = item;
        return true;
    };
    SessionStorage.prototype.getItem = function (key) {
        return this._internalStorage[key];
    };
    SessionStorage.prototype.removeItem = function (key) {
        if (key in this._internalStorage) {
            delete this._internalStorage[key];
        }
    };
    SessionStorage.prototype.removeItemContains = function (key) {
        var keys = Object.keys(this._internalStorage);
        key = keys.filter(function (z) { return z.indexOf(key) > -1; })[0];
        this.removeItem(key);
    };
    SessionStorage.prototype.getKeys = function () {
        return Object.keys(this._internalStorage);
    };
    return SessionStorage;
}());
var CacheKeys = /** @class */ (function () {
    function CacheKeys() {
    }
    CacheKeys.userId = "userId";
    CacheKeys.roleId = "roleId";
    CacheKeys.selectedFilters = "selectedFilters";
    return CacheKeys;
}());
export { CacheKeys };
